<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <span class="cs-title">历史记录</span>
                <el-row class="grid-content">
                  <el-col>
                    <pagination v-loading="loading" :data="logData" :option="paginationOption" @loadData="loadLogListData" @pageSizeChange="pageSizeChange"></pagination>

                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import pagination from "../../components/common/pagination";
import navigator from "../../components/navigator";
import { getUserActions } from "../../service/user.service";

export default {
  data() {
    return {
      loading: false,
      logData: {},
      pageSize: 20,
      paginationOption: {},
    };
  },
  components: {
    pagination,
    navigator
  },
  computed: {},
  created() {
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: true,
      hasDateSearch: true
    };

    let pageData = {
      pageSize: this.pageSize,
      pageNumber: 1
    };
    this.loadLogListData(pageData);
  },
  methods: {
    pageSizeChange(value){
       this.pageSize = value;
    },
    loadLogListData(pageData) {
      this.loading = true;
      getUserActions(pageData)
        .then(result => {
          if (result && result.success) {
            this.logData = result.data;
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/page/admin/logList.vue